import "styles/page/networth.page.css";
import React from "react";
import Navigation from "components/navigation/navigation";
import LoadingScreen from "components/loading.screen";
import OverviewPanel from "pages/networth/panels/overview.panel";
import NetWorthPanel from "pages/networth/panels/networth.panel";
import {useData} from "context/data.context";

const NetWorth = () => {
  const { loadingUserData, dataError, refreshData } = useData();

  if (loadingUserData) return <LoadingScreen />;
  if (dataError) return <LoadingScreen error={dataError} onRetry={refreshData} />;

  return (
    <div className="NetworthPage">
      <Navigation />
      <div className="Container">
        <NetWorthPanel />
        <OverviewPanel />
      </div>
    </div>
  );
};

export default NetWorth;
